import { render, staticRenderFns } from "./EditDriver.component.vue?vue&type=template&id=30d34876"
import script from "./EditDriver.component.vue?vue&type=script&lang=ts"
export * from "./EditDriver.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports